module.exports = __webpack_public_path__ + "tables/media/messages.6ba57c4d.svg";